import { Component, OnInit } from '@angular/core';
import { EmbryoService } from 'src/app/Services/Embryo.service';

@Component({
  selector: 'app-login-icon',
  templateUrl: './login-icon.component.html',
  styleUrls: ['./login-icon.component.css'],
})
export class LoginIconComponent implements OnInit {
  lang: any;
  constructor(public embryoService: EmbryoService) {
    this.embryoService.emitLang.subscribe((lang: any) => {
      this.lang = lang;
    });
  }

  ngOnInit() {}
}
